import React from 'react';

function App() {
  const value = 'Pit';
  return <div>{value}Hub</div>;
}

export default App;
